import React, {useEffect, useState} from "react";
import {BusinnesWrap} from "components/atoms/BusinessSetup/BusinessSetup.styles";
import Heading from "components/atoms/Auth/Heading";
import Form from "components/molecules/Form/Form";
import Field from "components/molecules/Field";
import {useForm} from "components/molecules/Form";
import Button from "components/molecules/Button";
import {useAuthContext} from "Context/authContext";
import {setBusinessSetup1} from "store/reducers/businessSlice";
import {useDispatch} from "react-redux";
import {useSelector} from "react-redux";

const BusinessDetails = ({setFormData, setCurrentStep, currentStep, totalSteps, prevData, logo, cuisine_data}) => {
    const [form] = useForm();
    const {user} = useAuthContext();
    const dispatch = useDispatch();
    const [phoneNumber, setPhoneNumber] = useState(false);
    const [radio, setRadio] = useState({
        delivery: true,
    });
    const {businessSetup1} = useSelector(state => state.business);

    console.log(businessSetup1);

    const [address, setAddress] = useState({
        street_address: "",
        city: "",
        state: "",
        country: "",
        postal_code: "",
        latlng: {
            // changed from latLang to latlng
            lat: null,
            lng: null,
        },
    });
    const dropdwonData = [
        {label: "Restaurant", value: "restaurant"},
        {label: "Bar Cafe", value: "cafe"},
    ];
    const deliveryData = [
        {label: "25–30 min", value: "25–30 min"},
        {label: "30–45 min", value: "30–45 min"},
    ];
    const categoryData = [
        {label: "Fast Food", value: "Fast Food"},
        {label: "Italian", value: "Italian"},
        {label: "Chinese", value: "Chinese"},
        {label: "Western", value: "Western"},
        // {label: "Ghost Restaurant", value: "Ghost Restaurant"},
        {label: "Cafe", value: "Cafe"},
    ];

    const handleSubmit = e => {
        // Handle multiple category selections
        let categories = [];

        // Check if category is an array (multiple selections)
        if (e.category && Array.isArray(e.category)) {
            categories = e.category.map(cat => cat.value).filter(cat => cat !== null && cat !== undefined);
        }
        // Check if category is a single object with value property
        else if (e.category && e.category.value) {
            categories = [e.category.value];
        }

        // If no categories were selected, default to 'Fast Food'
        if (categories.length === 0) {
            categories = ["Fast Food"];
        }

        const stepOne = {
            name: e.Business_Name,
            type: e.Business_Type.value,
            categories: categories,
            // Set cuisines to be the same as categories
            cuisines: categories,
            branches: e.branches,
            phone: e.phone,
            isNumberChecked: phoneNumber,
            freeDelivery: radio?.delivery,
            deliveryTime: e?.deliveryTime,
            email: e.email,
        };
        dispatch(setBusinessSetup1(stepOne));

        // console.log("Categories selected:", categories);
        // console.log("Step One data:", stepOne);

        setFormData(prev => ({
            ...prev,
            step1: {...stepOne},
        }));
        setCurrentStep(2);
    };

    useEffect(() => {
        if (phoneNumber) {
            form?.setFieldsValue({
                phone: user?.profile?.phone,
            });
        }
    }, [phoneNumber]);

    useEffect(() => {
        if (businessSetup1 && Object.keys(businessSetup1).length > 0) {
            form.setFieldsValue({
                Business_Name: businessSetup1?.name,
                email: businessSetup1?.email,
                branches: businessSetup1?.branches,
                phone: businessSetup1?.phone,
                category: categoryData?.find(data => data.value === businessSetup1?.categories[0]),
                Business_Type: dropdwonData?.find(data => data.value === businessSetup1?.type),
                deliveryTime: deliveryData?.find(data => data.value === businessSetup1?.deliveryTime?.value),
            });
            setRadio({delivery: businessSetup1?.freeDelivery});
            setAddress(prevData?.address);
            if (businessSetup1?.isNumberChecked) {
                setPhoneNumber(true);
            }
        }
    }, [businessSetup1, form]);

    return (
        <>
            <BusinnesWrap>
                <Heading heading="Set up your" ColoredText="Business!" />
                <Form form={form} onSubmit={handleSubmit}>
                    <div className="signup-fields">
                        <Form.Item
                            label="Business Name *"
                            type="name"
                            rounded
                            name="Business_Name"
                            lg
                            placeholder="Taste of Lahore"
                            $bgWhite
                            rules={[
                                {
                                    required: true,
                                    message: "Business name is required",
                                },
                            ]}>
                            <Field />
                        </Form.Item>
                        <Form.Item
                            label="Business Type *"
                            type="select"
                            rounded
                            name="Business_Type"
                            lg
                            placeholder="Restaurant"
                            $bgWhite
                            options={dropdwonData}
                            rules={[
                                {
                                    required: true,
                                    message: "Type is required",
                                },
                            ]}>
                            <Field />
                        </Form.Item>
                    </div>
                    <div className="signup-fields">
                        <Form.Item
                            label="Select Business Categories *"
                            type="select"
                            rounded
                            isMulti
                            name="category"
                            lg
                            placeholder="Restaurant"
                            $bgWhite
                            options={categoryData}
                            rules={[
                                {
                                    required: true,
                                    message: "Category is required",
                                },
                            ]}>
                            <Field />
                        </Form.Item>
                    </div>

                    {/* <Autocomplete
                    onLoad={autocomplete =>
                        autocomplete.addListener("place_changed", () => handlePlaceSelect(autocomplete.getPlace()))
                    }
                    options={{componentRestrictions: {country: "PK"}}}>
                    <div className="input map-input locate-input">
                        <Field
                            label="Select Business Address"
                            type="text"
                            placeholder="Enter your Delivery Address"
                            name="address"
                            value={address.street_address}
                            onChange={e =>
                                setAddress(prev => ({
                                    ...prev,
                                    street_address: e.target.value,
                                }))
                            }
                            parentClass="map-input-field"
                            $bgWhite
                        />
                    </div>
                </Autocomplete> */}
                    <div className="signup-fields">
                        <Form.Item
                            label="Business Email *"
                            rounded
                            name="email"
                            lg
                            placeholder="Enter your Email"
                            $bgWhite
                            rules={[
                                {
                                    required: true,
                                    message: "Email is required",
                                },
                            ]}>
                            <Field />
                        </Form.Item>
                    </div>
                    <Form.Item
                        label="Phone Number *"
                        type="phone"
                        rounded
                        name="phone"
                        lg
                        placeholder="3098487880"
                        bgWhite="white"
                        onChange={e => form.setFieldsValue({phone: e})}
                        rules={[
                            {
                                required: true,
                                message: "Phone number is required",
                            },
                            {
                                pattern: /^(?:\+1|1)?\s?(?:\([2-9]\d{2}\)|[2-9]\d{2})[\s.-]?[2-9]\d{2}[\s.-]?\d{4}$/,
                                message: "Enter a valid phone number",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                    <Form.Item
                        label="My Business Phone is the same as my Mobile Number."
                        type="checkbox"
                        value={phoneNumber}
                        onChange={e => setPhoneNumber(e.target.value)}
                        rounded
                        lg
                        $bgWhite>
                        <Field />
                    </Form.Item>
                    <p>Do you offer Free Delivery?</p>
                    <div className="questions">
                        <Form.Item
                            label="Yes"
                            type="radio"
                            name="operating_license_y"
                            value={radio.delivery === true}
                            onChange={() => setRadio(prev => ({...prev, delivery: true}))}>
                            <Field />
                        </Form.Item>
                        <Field
                            label="No"
                            type="radio"
                            name="operating_license_n"
                            value={radio.delivery === false}
                            onChange={() => setRadio(prev => ({...prev, delivery: false}))}
                        />
                    </div>
                    <Form.Item
                        label="Average Delivery Time?"
                        type="select"
                        rounded
                        name="deliveryTime"
                        lg
                        placeholder="25–30 min"
                        $bgWhite
                        options={deliveryData}>
                        <Field />
                    </Form.Item>

                    <div className="btn-holder">
                        <Button lg disabled={currentStep === totalSteps}>
                            Next
                        </Button>
                    </div>
                </Form>
            </BusinnesWrap>
        </>
    );
};

export default BusinessDetails;
